import React from 'react';
import {observer} from 'mobx-react';
import {Layout, Panel, Pagination, InteractiveContext, DropdownFilter, SearchBox} from 'shared/components';
import {withState, t} from 'shared/core';
import {types, endpoints} from 'main/tools';
import {BenefitUpdatesState} from '../state';
import {calendarDate} from 'shared/tools';
import BenefitUpdateForEmployee from './BenefitUpdateForEmployee';
import BenefitUpdatesEmptyState from './BenefitUpdatesEmptyState';
import {BenefitUpdate} from 'main/stores/benefits';
import _ from 'lodash';

function scopeFilters() {
  return [
    {
      id: 'all',
      display: t('benefits.updates.filters.All')
    },
    {
      id: 'rejected',
      display: t('benefits.updates.filters.Rejected')
    },
    {
      id: 'completed',
      display: t('benefits.updates.filters.Completed')
    }
  ];
}

const BenefitUpdateDigest = observer(({uiState}) => {
  const {updatesByDate, hasResults} = uiState;

  if (_.isEmpty(updatesByDate)) {
    return <BenefitUpdatesEmptyState hasResults={hasResults} />;
  }

  return (
    updatesByDate.map(updateWithDate => (
      <Panel.Stack className='mb2' key={updateWithDate.date}>
        <Panel>
          <Panel.Header title={calendarDate(updateWithDate.date)}></Panel.Header>
        </Panel>
        {updateWithDate.items.map(i => <BenefitUpdateForEmployee update={i} key={i.id}/>)}
      </Panel.Stack>
    )));
});

const FilterRow = observer(({...rest}) => {
  return (
    <Panel compact className='mb2'>
      <div className='FilterRow flex align-items-middle bg-white'>
        <div className='flex flex-wrap flex-grow row-gap-2'>
          <SearchBox {...rest} />
          <div className='flex align-items-center'>
            <DropdownFilter options={scopeFilters()} attr='status' {...rest} />
          </div>
        </div>
      </div>
    </Panel>
  );
});

const BenefitUpdates = observer(({uiState}) => {
  return (
    <Layout>
      <div className='relative'>
        <InteractiveContext
          proxy={{
            type: 'async',
            modelType: types.BENEFITS.UPDATE,
            model: BenefitUpdate,
            endpoint: endpoints.BENEFITS.UPDATES,
            pageSize: 50
          }}
          saveStateToUrl
          initialFilter={{search: '', status: 'all' }}
          searchable
          onRefresh={({data}) => uiState.onPagination(data)}
          >
            <FilterRow />
            <BenefitUpdateDigest uiState={uiState}/>
            <Pagination />
        </InteractiveContext>
      </div>
    </Layout>
  );
});

export default withState(BenefitUpdates, BenefitUpdatesState);
